import React from 'react'
import {BrowserRouter, Route} from 'react-router-dom'

import BlogInPressPage from '../../pages/master/blog_in_press/index'
import BlogInPressActionPage from '../../pages/master/blog_in_press/action'

export default function BlogInPressRoute(props) {
  return (
    <>
      <Route exact path={`${props.match.path}/`} component={BlogInPressPage} />
      <Route exact path={`${props.match.path}/action`} component={BlogInPressActionPage} />
    </>
  )
}
